import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ProgettiParse} from "../../../ParseClass/Progetti.Parse";
import {
    GlobalVariablesService,
    isNotNullOrUndefined, typeRole
} from "../../../providers/service/global-variables.service";
import {ThemeService} from "../../../providers/service/theme.service";
import {LocalStorageService, TYPEBACKENDENUM} from "../../../providers/service/local-storage.service";
import {UserService} from "../../../providers/service/user.service";
import {TranslateService} from "@ngx-translate/core";
import {InviteUserComponent} from "../../pop-up-component/invite-user/invite-user.component";
import {delay, switchMap} from "rxjs/operators";
import {EMPTY, Observable} from "rxjs";
import {AlertService} from "../../../providers/service/alert.service";
import {MatDialog} from "@angular/material/dialog";


@Component({
    selector: 'app-setting-option-button',
    templateUrl: './setting-option-button.component.html',
    styleUrls: ['./setting-option-button.component.scss'],
    standalone: false
})
export class SettingOptionButtonComponent implements OnInit, OnChanges {
    public darkModeOn = (this.localStorage.darkModeOn == null) ? true : this.localStorage.darkModeOn;
    public iconLanguage;
    disabledProject = false;
    @Input() currentUrl: string = '';
    @Input() flow: 'column' | 'row' = 'row';
    @Input() classTitleLink = 'not-show';
    @Input() isSystemAdmin:any
    loadInviteUser = false;

    constructor(private themingService: ThemeService,
                private globalVariable: GlobalVariablesService,
                private localStorage: LocalStorageService,
                private userService: UserService,
                private translate: TranslateService,
                private dialog: MatDialog,
                private alertService: AlertService,
    ) {
        this.iconLanguage = translate.currentLang;
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (isNotNullOrUndefined(changes.currentUrl)) {
            const disableButtonUrls = ['/project']
            if (disableButtonUrls.includes(this.currentUrl)) {
                this.disabledProject = true;
            } else {
                this.disabledProject = false;
            }
        }
    }


    get allProject() {
        return this.globalVariable.allProject;
    }

    get nameProject() {
        return this.globalVariable.currentProject?.name;
    }

    get currentProject() {
        return this.globalVariable.currentProject;
    }

    selectProject(progetto: ProgettiParse) {
        this.localStorage.projectId = progetto.objectId!;
    }


    public darkModeChangeValue(checked: boolean) {
        this.darkModeOn = checked;
        this.localStorage.darkModeOn = this.darkModeOn;
        const theme = (this.darkModeOn) ? "dark-theme" : "light-theme";
        this.changeTheme(theme);
    }

    changeTheme(theme: string) {
        this.themingService.theme.next(theme);
    }

    logout() {
        this.userService.logout$().subscribe(() => {
            this.localStorage.removeAllProjectItems();
        });
    }

    get versioneSoftware() {
        return this.globalVariable.versionSoftware
    }

    get nameUser() {
        return (this.userService.user) ? this.userService.user.get('name') : null;
    }

    setLanguage(language: string) {
        if (this.translate.getLangs().includes(language)) {
            this.translate.use(language);
            this.localStorage.selectedLang = language;
            this.iconLanguage = language;
        }
    }

    public inviteUser() {
        this.loadInviteUser = true;
        const projectPossibleValues = this.globalVariable.allProject;
        const formDefualtValue = {houseId: this.globalVariable.currentProject?.objectId};
        this.dialog.open(InviteUserComponent, {
            data: {
                projectPossibleValues,
                formDefualtValue
            },
            autoFocus: false,
            exitAnimationDuration: 0.1
        }).afterClosed()
            .pipe(
                switchMap(userDetail => {
                    if (userDetail != null) {
                        return this.userService.inviteUser$(userDetail.email, userDetail.houseId, userDetail.phone)
                    } else {
                        this.loadInviteUser = false;
                        return EMPTY;
                    }
                }))
            .subscribe(a => {
                this.loadInviteUser = false;
                this.alertService.success(this.translate.instant('alert.success'))
            }, error => {
                this.loadInviteUser = false;
                this.alertService.error(error)
            })
    }

    isEqualsProjectPredicate(project: ProgettiParse, current: ProgettiParse): boolean {
        if (current != null) {
            return current.objectId == project.objectId
        } else {
            return false;
        }
    }

    changeButtonTypeBackend(values: any) {
        this.localStorage.typeBackend = values
    }
}
